export function formatNationalId(value: string) {
  if (value.length === 11) {
    return value.slice(0, 6) + " " + value.slice(6);
  }
  return value;
}
